// libraries
import React from 'react'
import clsx from 'clsx'

// svg
import { BalloonLeft, BalloonRight } from '/react4xp/components/Svg/Others/Balloon'
import { BalloonArrowTopLeft, BalloonArrowTopRight, BalloonArrowBottomLeft, BalloonArrowBottomRight } from '/react4xp/components/Svg/Others/BalloonArrow'

// prop types
interface BalloonProps {
    className?: string
    balloonColor: 'white' | 'blue-light' | 'blue' | 'blue-dark' | 'green' | 'yoghurt' | 'yoghurt-dark' | 'black'
    balloonSide: 'left' | 'right'
    arrow: 'top-left' | 'top-middle' | 'top-right' | 'bottom-left' | 'bottom-middle' | 'bottom-right'
    arrowSide: 'left' | 'right'
    arrowSize: 'small' | 'medium' | 'big'
    spacing: 'smaller' | 'small' | 'medium' | 'big'
    children: React.ReactNode
    leftAligned?: boolean
}

export default function Balloon({ className, balloonColor, balloonSide, arrow, arrowSide, arrowSize, spacing, leftAligned, children }: BalloonProps) {
    return (
        <div className={clsx(
            'balloon',

            leftAligned && 'balloon--left-aligned',

            // balloon color
            balloonColor === 'white' && 'balloonBgWhite',
            balloonColor === 'blue-light' && 'balloonBgBlueLight',
            balloonColor === 'blue' && 'balloonBgBlue',
            balloonColor === 'blue-dark' && 'balloonBgBlueDark',
            balloonColor === 'green' && 'balloonBgGreen',
            balloonColor === 'yoghurt' && 'balloonBgYoghurt',
            balloonColor === 'yoghurt-dark' && 'balloonBgYoghurtDark',
            balloonColor === 'black' && 'balloonBgBlack',

            // arrow size
            arrowSize === 'small' && 'arrowSmall',
            arrowSize === 'medium' && 'arrowMedium',
            arrowSize === 'big' && 'arrowBig',

            // arrow position
            arrow === 'top-left' && 'arrowTopLeft',
            arrow === 'top-middle' && 'arrowTopMiddle',
            arrow === 'top-right' && 'arrowTopRight',
            arrow === 'bottom-left' && 'arrowBottomLeft',
            arrow === 'bottom-middle' && 'arrowBottomMiddle',
            arrow === 'bottom-right' && 'arrowBottomRight',

            // spacing
            spacing === 'smaller' && 'spacingSmaller',
            spacing === 'small' && 'spacingSmall',
            spacing === 'medium' && 'spacingMedium',
            spacing === 'big' && 'spacingBig',

            className
        )}>

            <div data-balloon className='balloon-content'>

                { balloonSide === 'left' ? <BalloonLeft /> :  <BalloonRight /> }

                <div className='relative z2'>
                    {children}
                </div>

            </div>

            <div data-arrow className={clsx(
                'arrow',

                // arrow direction (left / right)
                arrowSide === 'left' && 'arrowLeft',
                arrowSide === 'right' && 'arrowRight',
            )}>

                {/* render the arrow according to the position and direction */}
                {arrowSide === 'left' && (arrow === 'top-left' || arrow === 'top-middle' || arrow === 'top-right') && <BalloonArrowTopLeft />}

                {arrowSide === 'right' && (arrow === 'top-left' || arrow === 'top-middle' || arrow === 'top-right') && <BalloonArrowTopRight />}

                {arrowSide === 'left' && (arrow === 'bottom-left' || arrow === 'bottom-middle' || arrow === 'bottom-right') && <BalloonArrowBottomLeft />}
                
                {arrowSide === 'right' && (arrow === 'bottom-left' || arrow === 'bottom-middle' || arrow === 'bottom-right') && <BalloonArrowBottomRight />}

            </div>

        </div>
    )
}